import { prop } from 'ramda';

export const getLocale = prop('locale');

export const getLocalizedState = (state) => prop(getLocale(state));
